import { ACTUALLY_SUPPORTED_LANGUAGES } from '@splitfiesta/shared';

/**
 * Web path of the example CSV in the closest supported language. The files
 * live in `apps/web/public/import/`; their header row and category names stay
 * in English in every language because the file is what the "From a CSV file"
 * guide tells people to copy, and English is the one language every reader of
 * the guide shares.
 */
export function importExamplePath(language?: string | null): string {
  const base = (language ?? '').slice(0, 2).toLowerCase();
  const lang = (ACTUALLY_SUPPORTED_LANGUAGES as readonly string[]).includes(
    base
  )
    ? base
    : 'en';
  return `/import/example-${lang}.csv`;
}

/**
 * How to build a file by hand for the same parser, shown under the Splitwise
 * steps on web and mobile with a link to `importExamplePath`.
 */
export const CSV_GUIDE = {
  titleKey: 'import:sources.csv.title',
  ruleKeys: [
    'import:sources.csv.rules.columns',
    'import:sources.csv.rules.nets',
    'import:sources.csv.rules.save',
  ],
  downloadKey: 'import:sources.csv.download',
} as const;
